import { useApolloClient } from '@apollo/react-hooks';
import {
  OutageLookupParams,
  OutageLookupResponse,
} from '../../../../__generated__/pge-types';
import { getOutageLookupQuery } from '../queries/outage.query';
import useWrapWithLoader from '../../../../hooks/useWrapWithLoading';

export function useOutageLookUp() {
  const apolloClient = useApolloClient();
  const { wrapWithLoader } = useWrapWithLoader();

  const getOutageLookUpQueryResponse = wrapWithLoader(
    async (params: OutageLookupParams) => {
      const result = await apolloClient.query<
        { getOutageLookup: OutageLookupResponse },
        { params: OutageLookupParams }
      >({
        query: getOutageLookupQuery,
        variables: { params },
        fetchPolicy: 'network-only',
      });
      const getOutageLookupResponse = result?.data?.getOutageLookup;
      return getOutageLookupResponse;
    },
  );

  return {
    getOutageLookUpQueryResponse,
  };
}
